import { Component, OnInit } from '@angular/core';
import { take } from 'rxjs';
import { APIResponse } from 'fakturnia-shared';
import { ApiService } from 'shared/services/api.service';
import { CommonModule } from '@angular/common';
import { Router, RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';

interface Announcement {
  _id: string;
  title: string;
  description: string;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

@Component({
  standalone: true,
  imports: [
    CommonModule, 
    RouterLink,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatProgressSpinnerModule,
    MatTooltipModule
  ],
  selector: 'app-announcements',
  templateUrl: './announcements.component.html',
  styleUrls: ['./announcements.component.scss']
})
export class AnnouncementsComponent implements OnInit {

  announcements: Announcement[] = [];
  activeAnnouncements: Announcement[] = [];
  inactiveAnnouncements: Announcement[] = [];
  isLoading = true;
  displayedColumns: string[] = ['number', 'title', 'status', 'actions'];

  constructor(
    private _apiService: ApiService,
    private _router: Router
  ) {}

  ngOnInit(): void {
    this._get();
  }

  private _get() {
    this.isLoading = true;
    this._apiService.getAnnouncementsAsAdmin().pipe(take(1)).subscribe({
      next: (response: APIResponse) => {
        this.announcements = response.data;
        this._separateAnnouncements();
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }

  private _separateAnnouncements() {
    this.activeAnnouncements = this.announcements.filter(a => a.isActive);
    this.inactiveAnnouncements = this.announcements.filter(a => !a.isActive);
  }

  navigateToNew() {
    this._router.navigate(['/admin/announcements/new']);
  }

  navigateToEdit(id: string) {
    this._router.navigate(['/admin/announcements', id]);
  }

  getAnnouncementNumber(index: number, isActive: boolean): number {
    return isActive 
      ? index + 1 
      : this.activeAnnouncements.length + index + 1;
  }
}
